import { RampFormStore } from './RampFormStore';

// Stores information copied from UserFormStore, in addition a password field to create online account
export interface IOnlineUser {
    [key: string]: string | number | boolean | undefined;
    password: string;
}

export class OnlineSignUpFormStore extends RampFormStore<IOnlineUser> {
    constructor() {
        super({
            password: ''
        });
    }
}
